import { NodeViewWrapper } from '@tiptap/react'
import type { NodeViewProps } from '@tiptap/react'
import { wikiLinkData } from './wikiLinkData'

export default function WikiLinkView({ node }: NodeViewProps) {
  const noteId = node.attrs.noteId as string
  const { allNotes, onNavigate } = wikiLinkData
  const linked = allNotes.find(n => n.id === noteId)

  return (
    <NodeViewWrapper as="span" className="inline">
      <span
        onClick={() => onNavigate?.(noteId)}
        className={
          linked
            ? 'inline-flex items-center gap-1 bg-gold/10 text-gold border border-gold/20 rounded-full px-2 py-0.5 text-xs font-medium align-baseline mx-0.5 cursor-pointer'
            : 'inline-flex items-center gap-1 bg-rose/10 text-rose/60 border border-rose/20 rounded-full px-2 py-0.5 text-xs font-medium align-baseline mx-0.5'
        }
      >
        {linked ? `${linked.icon} ${linked.title}` : noteId}
      </span>
    </NodeViewWrapper>
  )
}
